import type { ColumnOrColumnGroup } from '@talos/kyoko';
import type { ValueGetterParams } from 'ag-grid-community';
import type { PriceGridEntity } from '../../PriceGridEntity';
import { PriceGridRowKind } from '../../PriceGridEntity';
import type { PriceGridLadderColumnConfig } from '../../columns/priceGridMarketDataQtyColumns';
import { getPriceGridMarketDataColumn, getPriceGridMarketDataColumnDynamics } from '../../hooks/dynamics';
import { isPriceLadderMode } from '../../ladder';

const SECURITY_MARKET_DATA_SYMBOL_COL_ID = 'SecurityMarketData-Symbol';

export function getGenericPriceGridColumns({
  isBBOEnabled,
  ladderConfig,
  showRFQ,
}: {
  isBBOEnabled: boolean;
  ladderConfig: PriceGridLadderColumnConfig;
  showRFQ: boolean;
}): ColumnOrColumnGroup[] {
  const isPriceMode = isPriceLadderMode(ladderConfig.ladderType);

  return [
    {
      type: 'productType',
      id: 'ProductType',
      field: 'security.Symbol',
      title: 'Product',
      initialWidth: 120,
    },
    {
      type: 'custom',
      id: 'Quantity',
      field: 'bucket.size',
      title: 'Qty',
      initialWidth: 100,
      // In Price mode bid/offer qty live inside the price group, so hide Qty via applyColumnState.
      // Qty is never listed in the column chooser; ladder mode controls visibility.
      suppressColumnsToolPanel: true,
      params: {
        colId: 'Quantity',
        headerName: 'Qty',
        valueGetter: (params: ValueGetterParams<PriceGridEntity, string>) => {
          const row = params.data;
          if (!row) {
            return undefined;
          }
          if (isPriceMode && row.kind === PriceGridRowKind.Child) {
            return '';
          }
          return row.bucket.size ?? '';
        },
      },
    },
    {
      type: 'dateOnly',
      id: 'Expiry',
      field: 'security.Expiration',
      title: 'Expiry',
      initialHide: true,
      sortable: true,
    },
    getPriceGridMarketDataColumn(
      getPriceGridMarketDataColumnDynamics({
        colID: SECURITY_MARKET_DATA_SYMBOL_COL_ID,
        title: 'Price',
      }),
      undefined,
      { includeRFQColumn: showRFQ, isBBOEnabled, ladderConfig }
    ),
  ];
}
